// CART SPEED FIX (23-09, op verzoek Finn) — Caldwell's live theme.js is een Shopify "generated
// asset" (build-time gebundeld), dus niet direct via de Admin API overschrijfbaar. Deze losse
// asset injecteert een snellere add-to-cart-flow bovenop de bestaande <product-form>-listener.
//
// Probleem: theme.js' ProductForm._onSubmit doet na cart/add.js een TWEEDE, sequentiële fetch
// naar cart.js (puur voor item_count) voordat de cart-drawer opent — dat kost ~150-300ms extra
// bovenop de ~700-800ms van add.js zelf, waardoor de drawer merkbaar trager opent dan op de
// Westbury store. Fix: open de drawer meteen na cart/add.js met een voorlopig item_count
// (huidige stand + toegevoegde hoeveelheid), en werk 'm op de achtergrond bij zodra de
// parallelle cart.js-fetch alsnog binnenkomt.
//
// Werkwijze: luistert op CAPTURE-phase naar submit-events op <product-form>-elementen, roept
// stopImmediatePropagation() aan zodat theme.js' eigen (tragere) listener niet meer draait, en
// voert daarna functioneel identieke logica uit — alleen met de niet-blokkerende cart.js-call.
(function () {
  'use strict';

  function getFetchCart() {
    // theme.js houdt een module-scoped `fetchCart`-variabele bij die niet globaal beschikbaar
    // is — we onderhouden hier onze eigen, kleine kopie op window die na elke cart:change wordt
    // bijgewerkt (theme.js dispatcht cart:change altijd bubbling op document.documentElement).
    return window.__caldwellCartSpeedFix.lastCart;
  }

  window.__caldwellCartSpeedFix = window.__caldwellCartSpeedFix || { lastCart: null };

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.cart) {
      window.__caldwellCartSpeedFix.lastCart = event.detail.cart;
    }
  });

  // Initiële cart-stand ophalen zodra het script laadt (zelfde als theme.js' fetchCart-module),
  // zodat het eerste "add to cart" ook al een correct voorlopig item_count heeft.
  fetch(`${window.Shopify.routes.root}cart.js`)
    .then((r) => r.json())
    .then((cart) => { window.__caldwellCartSpeedFix.lastCart = cart; })
    .catch(function () {});

  async function fastSubmit(event) {
    const form = event.target.closest('form[id]');
    if (!form || !form.matches('product-form, form[is="product-form"]')) return;
    if (window.themeVariables?.settings?.cartType !== 'drawer') return; // alleen relevant voor drawer-modus

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const submitButtons = Array.from(form.elements).filter((btn) => btn.type === 'submit');
    submitButtons.forEach((btn) => {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-busy', 'true');
    });

    const formData = new FormData(form);
    formData.set('sections', 'cart-drawer,variant-added');
    formData.set('sections_url', `${window.Shopify.routes.root}variants/${form.id.value}`);

    let response, responseJson;
    try {
      response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        body: formData,
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      responseJson = await response.json();
    } finally {
      submitButtons.forEach((btn) => {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-busy');
      });
    }

    if (!response.ok) {
      form.dispatchEvent(new CustomEvent('cart:error', {
        bubbles: true,
        detail: { error: responseJson && responseJson.description },
      }));
      return;
    }

    const addedQuantity = responseJson.hasOwnProperty('items')
      ? responseJson['items'].reduce((sum, item) => sum + (item.quantity || 0), 0)
      : (responseJson.quantity || 0);
    const previousCart = getFetchCart();
    const provisionalCart = {
      item_count: (previousCart && previousCart.item_count || 0) + addedQuantity,
      sections: responseJson['sections'],
    };

    form.dispatchEvent(new CustomEvent('variant:add', {
      bubbles: true,
      detail: {
        items: responseJson.hasOwnProperty('items') ? responseJson['items'] : [responseJson],
        cart: provisionalCart,
      },
    }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', cart: provisionalCart },
    }));

    // Achtergrond-fetch voor de definitieve totalen — blokkeert de al-geopende drawer niet meer.
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((r) => r.json())
      .then((cartContent) => {
        cartContent['sections'] = responseJson['sections'];
        window.__caldwellCartSpeedFix.lastCart = cartContent;
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart: cartContent },
        }));
      })
      .catch(function () {});
  }

  document.addEventListener('submit', fastSubmit, true); // capture-phase: draait vóór theme.js' eigen listener
})();
